'use client';

import React, { forwardRef, ReactElement } from 'react';
import { Button, ButtonProps } from '@mui/material';
import styled from '@emotion/styled';
import { color, opacity, spacing } from '@/theme/tokens';
import Link from 'next/link';

interface ButtonContainedNeutralProps extends ButtonProps {
    children: ReactElement | string;
    isActive?: boolean;
}

const StyledButton = styled(Button, {
    shouldForwardProp: prop => prop !== 'isActive',
})<{ isActive: boolean }>`
    text-transform: none;
    background-color: ${({ isActive }) => (isActive ? color.gray[95] : color.gray[80])};
    color: ${color.white[0]};
    height: 46px;
    padding: 0 ${spacing[20]};
    display: inline-flex;
    border-radius: 0;

    &:hover {
        background-color: ${color.gray[90]};
    }

    &:active {
        background-color: ${color.gray[95]};
    }

    &.Mui-disabled {
        background-color: ${opacity[30]};
    }

    &.Mui-focusVisible {
        background-color: ${color.gray[90]};
        outline: none;
    }
    &:focus-visible {
        outline: none;
    }
`;

const ButtonContainedNeutral = forwardRef<HTMLButtonElement, ButtonContainedNeutralProps>(
    ({ children, disabled, isActive = false, onClick, ...rest }, ref) => {
        return (
            <StyledButton
                disabled={disabled}
                onClick={onClick}
                disableRipple
                isActive={isActive}
                LinkComponent={Link}
                ref={ref}
                {...rest}
            >
                {children}
            </StyledButton>
        );
    }
);

ButtonContainedNeutral.displayName = 'ButtonContainedNeutral';

export default ButtonContainedNeutral;
